/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ product: NonNullable<unknown> }} Views_Scope_ProductInputs */

const en_views_scope_product = /** @type {(inputs: Views_Scope_ProductInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Everyone in ${i?.product}`)
};

const de_views_scope_product = /** @type {(inputs: Views_Scope_ProductInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alle in ${i?.product}`)
};

/**
* | output |
* | --- |
* | "Everyone in {product}" |
*
* @param {Views_Scope_ProductInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const views_scope_product = /** @type {((inputs: Views_Scope_ProductInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Views_Scope_ProductInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_views_scope_product(inputs)
	return en_views_scope_product(inputs)
});